import React from "react";
import { useSelector } from "react-redux";
import { capitalize } from "../../helpers/common";
import { formatNumber } from "../../helpers/unit";
import moment from "moment";
import { DISPLAY_DATETIME_FORMAT3 } from "../../constants";

export const LoadPreviewData = React.forwardRef((props, ref) => {
  const { load } = props;
  const weightShortName = useSelector(
    (state) => state.user.settings.weightShortName
  );
  const farmName = useSelector((state) => state.farm.currentFarm.farm_name);
  const farmAddress = useSelector((state) => state.farm.farmAddress);
  const timezoneIdentifier = useSelector(
    (state) => state.farm.currentFarm.timezone_identifier
  );

  const now = moment().utc().tz(timezoneIdentifier);
  const timezoneId = now.zoneAbbr();
  const currentDateTime = moment(now).format(DISPLAY_DATETIME_FORMAT3);

  return (
    <div className="content-body" ref={ref}>
      <div className="print-header with-date-time">
        <section>
          <div className="farm-name">{farmName}</div>
          <div className="header-align">
            {farmAddress.address && farmAddress.address.addressLineOne
              ? `${farmAddress.address.addressLineOne},`
              : null}
          </div>
          <div className="header-align">
            {farmAddress.address && farmAddress.address.addressLineTwo
              ? farmAddress.address.addressLineTwo
              : null}
          </div>
          <div className="header-align">{`${farmAddress.address && farmAddress.address.city
            ? `${farmAddress.address.city}, `
            : ""
            } 
                    ${farmAddress.address && farmAddress.address.state
              ? `${farmAddress.address.state}, `
              : ""
            }
                    ${farmAddress.address && farmAddress.address.zipCode
              ? `${farmAddress.address.zipCode}, `
              : ""
            }`}</div>
          <div className="header-align">
            {farmAddress.phone && farmAddress.phone[0]
              ? farmAddress.phone[0]
              : null}
          </div>
        </section>
        <section className="header-right-_section">
          <div className="header-date-time">
            {currentDateTime} {timezoneId}
          </div>
        </section>
      </div>
      <div className="print-body">
        <div className="container">
          <div className="row-align">
            <div className="left-col-algin">LOT # :</div>
            <div className="answer-border" />
            <div className="right-col-algin">CROP :</div>
            <div className="answer-border">
              {load && load.crop_name && load.crop_name !== "Unknown"
                ? load.crop_name
                : ""}
            </div>
          </div>
          <div className="row-align">
            <div className="left-col-algin">GROWER'S NAME : </div>
            <div className="answer-border" />
            <div className="right-col-algin">GROWER #:</div>
            <div className="answer-border" />
          </div>
          <div className="row-align">
            <div className="left-col-algin">TRUCK # :</div>
            <div className="answer-border answer">
              {load &&
                load.target_equipment_group_name &&
                load.target_equipment_group_name !== "Unknown"
                ? load.target_equipment_group_name
                : ""}
            </div>
            <div className="right-col-algin">CONTRACT/P.O # :</div>
            <div className="answer-border" />
          </div>
          <div className="row-align">
            <div className="left-col-algin">STORAGE # :</div>
            <div className="answer-border answer">
              {load &&
                load.offload_geo_storage_location_name &&
                load.offload_geo_storage_location_name !== "Unknown"
                ? load.offload_geo_storage_location_name
                : ""}
            </div>
            <div className="right-col-algin">PIPE # :</div>
            <div className="answer-border answer">
              {load && load.pipe && load.pipe !== "Unknown" ? load.pipe : ""}
            </div>
          </div>
          <div className="row-align">
            <div className="left-col-algin">FIELD # :</div>
            <div className="answer-border answer">
              {load &&
                load.field_geo_shape_name &&
                load.field_geo_shape_name !== "Unknown"
                ? load.field_geo_shape_name
                : ""}
            </div>
            <div className="right-col-algin">REF # :</div>
            <div className="answer-border" />
          </div>
        </div>
        <div className="gross-light-tare-net">
          <div className="row-align col-display">
            <span className="gross">
              GROSS{" "}
              <span className="weight-name">{`(${capitalize(
                weightShortName
              )})`}</span>{" "}
              :
            </span>
          </div>
          <div className="answer-border answer">
            {load &&
              load.load_gross_weight &&
              load.load_gross_weight !== "Unknown"
              ? formatNumber(load.load_gross_weight)
              : load.estimated_load_capacity
                ? formatNumber(load.estimated_load_capacity)
                : ""}
          </div>
          <div className="row-align col-display">
            <span className="lightweight">
              LIGHTWEIGHT{" "}
              <span className="weight-name">{`(${capitalize(
                weightShortName
              )})`}</span>{" "}
              :
            </span>
          </div>
          <div className="answer-border answer">
            {load && load.light_weight && load.light_weight !== "Unknown"
              ? formatNumber(load.light_weight)
              : ""}
          </div>
          <div className="row-align col-display">
            <span className="tare">
              TARE{" "}
              <span className="weight-name">{`(${capitalize(
                weightShortName
              )})`}</span>{" "}
              :
            </span>
          </div>
          <div className="answer-border answer">
            {load && load.tare_weight && load.tare_weight !== "Unknown"
              ? formatNumber(load.tare_weight)
              : ""}
          </div>
          <div className="row-align col-display">
            <span className="net">
              NET{" "}
              <span className="weight-name">{`(${capitalize(
                weightShortName
              )})`}</span>
              :
            </span>
          </div>
          <div className="answer-border answer">
            {load && load.load_capacity && load.load_capacity !== "Unknown"
              ? formatNumber(load.load_capacity)
              : ""}
          </div>
        </div>
        <div className="comments">
          <div>COMMENTS :</div>
        </div>
        <div className="container driver-weigher-unloader-digger">
          <div className="row-align">
            <div className="left-col-algin">DRIVER :</div>
            <div className="answer-border answer">
              {load && load.operator_name && load.operator_name !== "Unknown"
                ? load.operator_name
                : ""}
            </div>
            <div className="right-col-algin">WEIGHER :</div>
            <div className="answer-border answer">
              {load &&
                load.modified_by_name_from_queue &&
                load.modified_by_name_from_queue !== "Unknown"
                ? load.modified_by_name_from_queue
                : ""}
            </div>
          </div>
          <div className="row-align">
            <div className="left-col-algin">UNLOADER :</div>
            <div className="answer-border answer">
              {load &&
                load.approved_by_name &&
                load.approved_by_name !== "Unknown"
                ? load.approved_by_name
                : ""}
            </div>
            <div className="right-col-algin">DIGGER :</div>
            <div className="answer-border">
              {load &&
                load.source_operator_name &&
                load.source_operator_name !== "Unknown"
                ? load.source_operator_name
                : ""}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});